// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3j4Yb","colBig":"styles_colBig__TlRFB","colSmall":"styles_colSmall___BcgV"};